import styled from 'styled-components';
import { InputStyle } from '../../atoms/input/input';

export const GroupIndicatorIcon = styled.div`
  padding-right: var(--spacing-03);
  display: flex;
  svg {
    margin: 0;
    fill: var(--icon-secondary);
  }
  color: var(--icon-secondary);
`;

export const AccordionHeader = styled.div`
  display: flex;
  align-items: center;
  padding-left: var(--spacing-05);
  top: 50%;
  position: relative;
  transform: translateY(-50%);
`;

export const StickyHeaderWrapper = styled.div`
  left: 0;
  right: 0;

  .sticky {
    position: sticky;
    top: 0;
    z-index: 999;
    background: #fff;
    height: 36px;
    color: var(--gray-50) !important;
    &:hover {
      background: var(--coolest-gray-10) !important;
    }
  }
`;

export const GroupedDropdownTrigger = styled.div`
  ${InputStyle};
  width: 240px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;
